'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var isArray = require('../compat/predicate/isArray.js');
var isPlainObject = require('../compat/predicate/isPlainObject.js');
var snakeCase = require('../string/snakeCase.js');
function toSnakeCaseKeys(obj) {
    if (isArray.isArray(obj)) {
        return obj.map(function(item) {
            return toSnakeCaseKeys(item);
        });
    }
    if (isPlainObject.isPlainObject(obj)) {
        var result = {};
        var keys = Object.keys(obj);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            var snakeKey = snakeCase.snakeCase(key);
            var convertedValue = toSnakeCaseKeys(obj[key]);
            result[snakeKey] = convertedValue;
        }
        return result;
    }
    return obj;
}
exports.toSnakeCaseKeys = toSnakeCaseKeys;
